export default "__VITE_ASSET__VYDRL56E__"